import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { resume } from '../lib/resume.js';

const PAGE_TITLE = 'Mike Moe - Resume';

function hostLabel(url) {
  try {
    return new URL(url).host.replace(/^www\./, '');
  } catch {
    return url;
  }
}

export default function Resume() {
  useEffect(() => {
    const previous = document.title;
    document.title = PAGE_TITLE;
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <div className="resume">
      <div className="resume-toolbar">
        <p>
          A one-page snapshot of selected work from my portfolio.
          {' '}<Link to="/">See the full overview</Link>.
        </p>
        <button type="button" className="resume-print-btn" onClick={() => window.print()}>
          Print / Save PDF
        </button>
      </div>

      <article className="resume-sheet" aria-label="Resume">
        <div className="resume-masthead">
          <div className="resume-identity">
            <p className="resume-kicker">Resume</p>
            <h2>{resume.name}</h2>
            <p className="resume-role">{resume.title}</p>
          </div>
          <img
            src="/favicon.png"
            alt="Pixel art Konlet portrait of Mike Moe"
            className="resume-portrait"
            width={72}
            height={72}
          />
        </div>

        <ul className="resume-contacts">
          <li>{resume.location}</li>
          <li>
            <a href={`mailto:${resume.email}`}>{resume.email}</a>
          </li>
          <li>
            <a href={resume.site} target="_blank" rel="noopener noreferrer">
              {hostLabel(resume.site)}
            </a>
          </li>
          <li>
            <a href={resume.github} target="_blank" rel="noopener noreferrer">
              github.com/konlet
            </a>
          </li>
          <li>
            <a href={resume.twitter} target="_blank" rel="noopener noreferrer">
              {resume.twitterHandle}
            </a>
          </li>
        </ul>

        <div className="resume-body">
          <aside className="resume-rail">
            <section>
              <h3>Skills</h3>
              {resume.skills.map((skill) => (
                <div key={skill.group} className="resume-skill-group">
                  <p className="resume-skill-label">{skill.group}</p>
                  <ul>
                    {skill.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </section>

            <section>
              <h3>Education</h3>
              {resume.education.map((edu) => (
                <div key={edu.title} className="resume-edu">
                  <p className="resume-edu-title">
                    {edu.href ? (
                      <a href={edu.href} target="_blank" rel="noopener noreferrer">
                        {edu.title}
                      </a>
                    ) : (
                      edu.title
                    )}
                  </p>
                  <p>{edu.place}</p>
                  <p className="resume-edu-detail">{edu.detail}</p>
                </div>
              ))}
            </section>
          </aside>

          <div className="resume-main">
            <section>
              <h3>Summary</h3>
              <p className="resume-summary">{resume.summary}</p>
            </section>

            <section>
              <h3>Experience</h3>
              <ol className="resume-jobs">
                {resume.experience.map((job) => (
                  <li key={`${job.company}-${job.duration}`}>
                    <div className="resume-job-head">
                      <div>
                        <p className="resume-job-company">{job.company}</p>
                        <p className="resume-job-role">{job.role}</p>
                      </div>
                      <p className="resume-job-dates">{job.duration}</p>
                    </div>
                    <ul>
                      {job.points.map((point) => (
                        <li key={point}>{point}</li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ol>
            </section>

            <section>
              <h3>Selected Work</h3>
              <ul className="resume-projects">
                {resume.projects.map((project) => (
                  <li key={project.name}>
                    <div className="resume-project-head">
                      <a href={project.href} target="_blank" rel="noopener noreferrer">
                        {project.name}
                      </a>
                      <span>{project.tag}</span>
                    </div>
                    <p>{project.blurb}</p>
                  </li>
                ))}
              </ul>
            </section>
          </div>
        </div>
      </article>
    </div>
  );
}
